import { createAction } from 'typesafe-actions';
export var windowConfigActions = {
  adjustViewport: createAction('WIN_CONF_ADJUST_VIEWPORT', function (resolve) {
    return function (viewportWidth, isMobile) {
      return resolve({
        viewportWidth: viewportWidth,
        isMobile: isMobile
      });
    };
  })
};